var _defs, _rect;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProfileBackImg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 130,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "spacedSeamlessWaves130",
    width: 100,
    height: 130,
    patternUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0 15 Q 25 5, 50 15 T 100 15",
    fill: "none",
    stroke: "#e5791b",
    strokeWidth: 1,
    opacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 0 50 Q 25 40, 50 50 T 100 50",
    fill: "none",
    stroke: "#e5791b",
    strokeWidth: 1,
    opacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 0 85 Q 25 75, 50 85 T 100 85",
    fill: "none",
    stroke: "#e5791b",
    strokeWidth: 1,
    opacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 0 120 Q 25 110, 50 120 T 100 120",
    fill: "none",
    stroke: "#e5791b",
    strokeWidth: 1,
    opacity: 0.07
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: "100%",
    height: "100%",
    fill: "url(#spacedSeamlessWaves130)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileBackImg);
export default __webpack_public_path__ + "static/media/profile_back_img.61c7e6de1ede50f16a0a197061062688.svg";
export { ForwardRef as ReactComponent };